export default __webpack_public_path__ + "static/media/building-front.a2ca80d3.jpg";